import { createSlice } from "@reduxjs/toolkit";
import {fetchChatReport, fetchHumanServiceChats, fetchChatReportTableColumnNames, fetchClientUsers, fetchHumanCategoriesAll} from "./thunk";
import { toast } from "react-toastify";
import { uploadCategoryIcon, fetchHumanCategories, getChatSessionHistory } from "../thunks";

const initialState = {
  chatSession: [],
  humanCategories: [],
  clientUsers: [],
  tableColumnNames: [],
  chats: [],
  loading: false,
  clientUsersloading: false,
  categoryloading: false,
  chatloading: false,
  error: null,
};

const ChatReportSlice = createSlice({
  name: "ChatReport",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

    // Fetch Chat Report Table Column Names
    .addCase(fetchChatReportTableColumnNames.pending, (state) => {
        state.loading = true;
        state.error = null;
    })
    .addCase(fetchChatReportTableColumnNames.fulfilled, (state, action) => {
        state.loading = false;
        state.tableColumnNames = action.payload;
    })
    .addCase(fetchChatReportTableColumnNames.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })


    .addCase(fetchChatReport.pending, (state) => {
        state.loading = true;
        state.error = null;
    })
    .addCase(fetchChatReport.fulfilled, (state, action) => {
        state.loading = false;
        state.chatSession = action.payload;
    })
    .addCase(fetchChatReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })

    .addCase(fetchHumanServiceChats.pending, (state) => {
        state.chatloading = true;
        state.error = null;
    })
    .addCase(fetchHumanServiceChats.fulfilled, (state, action) => {
        state.chatloading = false;
        state.chats = action.payload;
    })
    .addCase(fetchHumanServiceChats.rejected, (state, action) => {
        state.chatloading = false;
        state.error = action.payload;
    })

    .addCase(fetchHumanCategoriesAll.pending, (state) => {
        state.categoryloading = true;
        state.error = null;
    })
    .addCase(fetchHumanCategoriesAll.fulfilled, (state, action) => {
        state.categoryloading = false;
        state.humanCategories = action.payload;
    })
    .addCase(fetchHumanCategoriesAll.rejected, (state, action) => {
        state.categoryloading = false;
        state.error = action.payload;
    })

    .addCase(fetchClientUsers.pending, (state) => {
        state.clientUsersloading = true;
        state.error = null;
    })
    .addCase(fetchClientUsers.fulfilled, (state, action) => {
        state.clientUsersloading = false;
        state.clientUsers = action.payload;
    })
    .addCase(fetchClientUsers.rejected, (state, action) => {
        state.clientUsersloading = false;
        state.error = action.payload;
    })

    // .addCase(addHumanCategory.pending, (state) => {
    //     state.error = null;
    // })
    // .addCase(addHumanCategory.fulfilled, (state, action) => {
    //     state.humanCategories.unshift(action.payload);
    // })
    // .addCase(addHumanCategory.rejected, (state, action) => {
    //     state.error = action.payload;
    // })

    // .addCase(updateHumanCategory.pending, (state) => {
    //     state.error = null;
    // })
    // .addCase(updateHumanCategory.fulfilled, (state, action) => {
    //     const index = state.humanCategories.findIndex(
    //         (item) => item.ID === action.payload.ID
    //     );
    //     if (index !== -1) {
    //         state.humanCategories[index] = action.payload;
    //     }
    // })
    // .addCase(updateHumanCategory.rejected, (state, action) => {
    //     state.error = action.payload;
    // })

    // .addCase(deleteHumanCategory.pending, (state) => {
    //     state.error = null;
    // })
    // .addCase(deleteHumanCategory.fulfilled, (state, action) => {
    //     state.humanCategories = state.humanCategories.filter(
    //         (item) => item.ID !== action.payload[0].ID
    //     );
    // })
    // .addCase(deleteHumanCategory.rejected, (state, action) => {
    //     state.error = action.payload;
    // })

    // .addCase(activateDeactivateHumanCategory.pending, (state) => {
    //     state.error = null;
    // })
    // .addCase(activateDeactivateHumanCategory.fulfilled, (state, action) => {
    //     const index = state.humanCategories.findIndex(
    //         (item) => item.ID === action.payload.ID
    //     );
    //     if (index !== -1) {
    //         state.humanCategories[index] = action.payload;
    //     }
    // })
    // .addCase(activateDeactivateHumanCategory.rejected, (state, action) => {
    //     state.error = action.payload;
    // })

    
  },
});

export default ChatReportSlice.reducer;
